export default __webpack_public_path__ + "static/media/file-pdf.849c68a3.svg";